import { useNavigate } from "react-router-dom";
import { Progress } from "antd";
import { getUrgencyProgress } from "../utils/getProgress";
import { SEMAFORO_COLORS } from "../constants";

export const StatusRow = ({ servicio, reglas }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/ConsesionariosDetalle/${servicio.id}`);
  };

  const horas = servicio.horasTranscurridas;
  const tiempoTexto =
    horas !== null
      ? horas >= 24
        ? `${Math.floor(horas / 24)}d ${Math.floor(horas % 24)}h`
        : `${Math.floor(horas)}h ${Math.floor((horas % 1) * 60)}m`
      : "-";

  const progressPercent = getUrgencyProgress(horas, reglas);

  return (
    <tr
      className={`semaforo-dinamico__row ${servicio.colorClass}`}
      onClick={handleClick}
    >
      <td className="semaforo-dinamico__cell--id">{servicio.id}</td>
      <td className="semaforo-dinamico__cell">{servicio.siniestro}</td>
      <td className="semaforo-dinamico__cell--time">{tiempoTexto}</td>
      <td className="semaforo-dinamico__cell--urgency">
        <div className="semaforo-dinamico__urgency-container">
          <Progress
            percent={progressPercent}
            size="small"
            strokeColor={SEMAFORO_COLORS.blue}
            format={() => null}
            className="semaforo-dinamico__progress"
          />
        </div>
      </td>
    </tr>
  );
};